import type { Theme } from '@mui/material';
import { alpha } from '@mui/material/styles';

export const styles = {
  wrapper: (theme: Theme) => ({
    position: 'absolute',
    left: 0,
    bottom: 0,
    height: '100%',
    width: '100%',
    bgcolor: alpha(theme.colors.white, 0.7),
    px: 4,
    pb: 2,
    justifyContent: 'flex-end',
  }),

  errorBox: (theme: Theme) => ({
    padding: 2.25,
    justifyContent: 'center',
    bgcolor: theme.colors.error[50],
    color: theme.colors.error[600],
    border: `1px solid ${theme.colors.error[600]}`,
    borderRadius: '12px',
    cursor: 'pointer',

    svg: {
      transform: 'scale(-1, 1)',
    },
  }),
};
